



























































































































































































import { Component, Watch } from "vue-property-decorator";
import Vue from "vue";
import { userModule } from "@/store/modules/user";
import ModalKonfirmasi from "@/components/modal/ModalKonfirmasi.vue";
import { appModule } from "./store/modules/app";
import ModalAlert from "@/components/modal/ModalAlert.vue";
import http from "@/axios/http-common";
// import { storePegawai } from "./store/modules/pegawai";
import { storeReferensi } from "@/store/modules/referensi";
import { storeBed } from "./store/modules/bed";
import DataBed from "./services/DataBed";

@Component({
  components: {
    ModalKonfirmasi,
    ModalAlert
  }
})
// @Component
export default class App extends Vue {
  get signedIn() {
    return userModule.isSignedIn;
  }

  get user() {
    return userModule.user;
  }

  get showAlert() {
    return appModule.alert;
  }

  get errItem() {
    return {
      errorMsg: appModule.alertMessage,
      errorIcon: "mdi-alert-circle-outline"
    };
  }

  get akses() {
    return storeBed.akses;
  }

  private dialog = false;
  private mini = false;
  private dialogText = "";
  private dialogTitle = "";
  private isRootComponent = true;
  public drawer = window.innerWidth > 960;
  public rightDrawer = false;
  // public drawer = window.innerWidth > 550;
  private fixed = false;
  // private items: AppMenu[] = [
  //   {
  //     icon: "mdi-view-dashboard",
  //     title: "Laporan Presensi",
  //     vertical: "Laporan Presensi",
  //     link: "laporan-presensi",
  //   },
  //   {
  //     icon: "mdi-delete-empty",
  //     title: "Hapus SIMCARD",
  //     vertical: "Hapus SIMCARD",
  //     link: "hapus-simcard",
  //   },
  // ];

  private userMenus: AppMenu[] = [
    // {
    //   icon: "bubble_chart",
    //   title: "Change Password",
    //   link: "changepassword",
    // },
    {
      icon: "bubble_chart",
      title: "Logout",
      link: "login"
    }
  ];

  private miniVariant = false;
  private right = true;

  private menuItem = "";
  modalOpenKonfirmasi = false;
  msgConfirm = "";
  pasienSearch = null;
  pasienItems = [];
  pasien = "";
  isLoading;
  _timerId;
  showData = false;

  created() {
    //  [App.vue specific] When App.vue is first loaded start the progress bar
    // storePegawai.actCekAksesPegawai(this.user["pegawai_id"]);
    this.cekAkses();
    storeReferensi.actDokter();
    storeReferensi.actUnitAll();
    storeReferensi.actUnit();
    storeReferensi.actKelas();
    storeReferensi.actStatus();
    this.$Progress.start();
    //  hook the progress bar to start before we move router-view
    this.$router.beforeEach((to, _from, next) => {
      //  does the page we want to go to have a meta.progress object
      if (to.meta.progress !== undefined) {
        const meta = to.meta.progress;
        // parse meta tags
        this.$Progress.parseMeta(meta);
      }

      //  start the progress bar
      this.$Progress.start();

      //  continue to next page
      next();
    });
    //  hook the progress bar to finish after we've finished moving router-view
    this.$router.afterEach(to => {
      // this.$router.afterEach((to, from) => {
      if (to.name !== "ErrorPage") {
        this.menuItem = to.name;
      }
      //  finish the progress bar
      this.$Progress.finish();
    });
  }

  get activeMenuItem() {
    return this.menuItem;
  }

  get bottomSnackbar() {
    return appModule.snackbar;
  }
  set bottomSnackbar(val) {
    appModule.setSnackbar(val);
  }

  get bottomSnackbarText() {
    return appModule.notice;
  }

  get alertSnackbar() {
    return appModule.snackbaralert;
  }
  set alertSnackbar(val) {
    appModule.setSnackbaralert(val);
  }

  get alertSnackbarText() {
    return appModule.noticealert;
  }

  @Watch("signedIn")
  changedSigned(v) {
    if (v) {
      this.cekAkses();
    }
  }

  cekAkses() {
    if (this.user["pegawai_id"]) {
      const dt = DataBed.getRoleUser(this.user["pegawai_id"]);
      dt.then(dt => {
        if (dt["status"] != 1) {
          this.logout();
          appModule.sendErrorAlert("Anda Tidak Memiliki Akses Masuk");
          // alert("Anda Tidak Memiliki Akses Masuk");
        } else {
          // appModule.sendErrorAlert("Oke anda memiliki akses");
          storeBed.actAkses(dt.data);
          //isi store hak akses
        }
        // this.SET_ROLE(role);
      });
    }
  }

  handleNavigtiion(item: TODO) {
    this.menuItem = item.title;
    this.$router.push({
      name: item.link
    });
  }
  logout() {
    userModule.logout();
    this.$router.push("login");
  }
  handleUserActions(item: TODO) {
    // async handleUserActions(item: TODO) {
    this.menuItem = item.title;
    if (item.title === "Logout") {
      this.modalOpenKonfirmasi = true;
      this.msgConfirm = "Anda yakin ingin keluar aplikasi?";
      // userModule.logout();
      // await userModule.logout();
      // console.log(item.link);
    } else {
      this.$router.push(item.link);
    }
  }
  // filterObject(item, queryText, itemText) {
  //   return (
  //     item.rm.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 ||
  //     item.nama.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
  //   );
  // }
  @Watch("pasienSearch")
  changedval() {
    this.pasienItems = [];
    this.showData = false;
    clearTimeout(this._timerId);
    this._timerId = setTimeout(() => {
      if (this.pasienSearch === null || this.pasienSearch.length < 2) return;
      //   this.isLoading = true;
      //   http
      //     .getDataParam("/pasien", {
      //       params: { term: this.pasienSearch },
      //     })
      //     .then((res) => {
      //       this.pasienItems = res.data;
      //     })
      //     .catch((err) => {
      //       console.log(err);
      //     })
      //     .finally(() => (this.isLoading = false));
      //   this.isLoading = false;
    }, 500);
  }
  selectPasien(v) {
    this.$router.push({
      name: `detail-pasien`,
      params: {
        rm: v.rm
      }
    });
    this.$nextTick(() => {
      this.pasienSearch = null;
      this.pasienItems = [];
    });
  }
  getListPasien() {
    this.pasienItems = [];
    http
      .getDataParam("/pasien", {
        params: { term: this.pasienSearch }
      })
      .then(res => {
        if (res.data.length > 0) {
          this.showData = false;

          this.pasienItems = res.data;
        } else {
          // this.pasienItems = [];
          this.showData = true;
          // appModule.sendErrorAlert("Data tidak ditemukan");
          // appModule.NoticeDelayAlert("Data Pasien tidak ditemukan");
        }
      })
      .catch(err => {
        console.log(err);
      });
  }

  mounted() {}
}
